/**
 * 客户端入口文件
 * 负责将应用挂载到DOM并进行水合处理
 */

import { createHead } from '@vueuse/head'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/element-theme.css'
import './assets/styles/global.css'
import router from './router'
import { installUtils } from './utils'
// 导入Swiper基础样式 - 按需加载Swiper模块，减少初始包体积
import 'swiper/swiper-bundle.css'

// 导出创建应用的工厂函数
export async function createVueApp() {
  const app = createApp(App)
  const pinia = createPinia()
  const head = createHead({
    titleTemplate: (title) => (title ? `${title} | 联合毕设` : '联合毕设'),
    meta: [
      { charset: 'UTF-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
      { name: 'description', content: '联合毕设是一个专注于创意设计和产业转化的平台' },
      { name: 'keywords', content: '联合毕设,创意设计,产业转化,线上展览,新闻动态,选题分类' }
    ]
  })



  // 启用状态持久化插件
  pinia.use(piniaPluginPersistedstate)

  // 注册插件
  app.use(head)
  app.use(pinia)
  app.use(router)
  app.use(installUtils)
  app.use(ElementPlus, {
    zIndex: 3000,
    size: 'default',
    locale: {
      name: 'zh-cn',
      el: {
        colorpicker: {
          confirm: '确定',
          clear: '清空',
        },
      },
    },
  })
  
  // 移除全局Swiper配置，改为按需加载以优化包体积

  // 路由准备
  await router.isReady()

  return {
    app,
    router,
    head
  }
}

// 客户端挂载
if (import.meta.env.SSR === false) {
  createVueApp().then(({ app }) => {
    app.mount('#app')
  })
}